import React, { lazy, Suspense, useEffect, useRef, useState } from 'react';
import Home from './components/Home';
import Navbar from './components/Navbar';

import './App.css';

const About = lazy(() => import('./components/About'));
const Skills = lazy(() => import('./components/Skills'));
const TechStack = lazy(() => import('./components/TechStack'));
const Works = lazy(() => import('./components/Works'));
const Experience = lazy(() => import('./components/Experience'));
const Contact = lazy(() => import('./components/Contact'));

function LazySection({ children, id, minHeight }) {
  const sectionRef = useRef(null);
  const [shouldRender, setShouldRender] = useState(
    () => process.env.NODE_ENV === 'test' || typeof IntersectionObserver === 'undefined'
  );

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldRender(true);
          observer.disconnect();
        }
      },
      { rootMargin: '400px 0px' }
    );

    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div id={id} ref={sectionRef} style={{ minHeight }}>
      {shouldRender && <Suspense fallback={null}>{children}</Suspense>}
    </div>
  );
}

function App() {
  return (
    <div className='overflow-y-hidden max-w-full'>
      <Navbar />
      <main>
        <Home />
        <LazySection id='about' minHeight='800px'><About /></LazySection>
        <LazySection id='skills' minHeight='500px'><Skills /></LazySection>
        <LazySection minHeight='700px'><TechStack /></LazySection>
        <LazySection id='works' minHeight='1026px'><Works /></LazySection>
        <LazySection id='experience' minHeight='700px'><Experience /></LazySection>
        <LazySection id='contact' minHeight='900px'><Contact /></LazySection>
      </main>
    </div>
  );
}

export default App;
